import React from 'react'
import PropTypes from 'prop-types'
import DropLayer from '../modal/drop-layer'
import Select from '../forms/select'

import { ITEM_CATEGORIES } from '../../services/mycharity/item/constants'

const options = ITEM_CATEGORIES.map(item => ({
  name: item,
  value: item,
  disabled: false,
  hidden: false
}))

options.unshift({
  name: 'All',
  value: ''
})

class Filters extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      filter: props.currentFilter
    }

    this.onFilterChange = this.onFilterChange.bind(this)
    this.applyFilters = this.applyFilters.bind(this)
  }

  render() {
    const { isOpen, toggleFilters } = this.props
    return (
      <DropLayer
        theme='light-theme'
        text='Filters'
        barTheme='light-bar'
        hasFooter
        isOpen={isOpen}
        onCloseButtonClick={toggleFilters}
        onFooterButtonClick={this.applyFilters}
      >
        <form className='inner-wrapper'>
          <Select
            theme='light-theme'
            label='What kind of product do you like?'
            id='product-category'
            options={options}
            value={this.state.filter}
            onChange={this.onFilterChange}
          />
        </form>
      </DropLayer>
    )
  }

  onFilterChange(event) {
    this.setState({
      filter: event.target.value
    })
  }

  applyFilters() {
    const { setFilter, toggleFilters, searchItems, clearItems } = this.props
    setFilter(this.state.filter)
    toggleFilters()
    clearItems('items')
    searchItems()
  }
}

Filters.propTypes = {
  isOpen: PropTypes.bool,
  toggleFilters: PropTypes.func,
  setFilter: PropTypes.func,
  searchItems: PropTypes.func
}

Filters.defaultProps = {
  isOpen: true
}

export default Filters



// WEBPACK FOOTER //
// ./src/ui/views/filters.js